function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import useAsset from '../../../hook/useAsset';
export function formatResultsData(answerTypes, result, tapAnswers, questionType, chartWaveLabels, usePercentage) {
    var expectAnswers = answerTypes.includes(questionType);
    if (expectAnswers && !(tapAnswers === null || tapAnswers === void 0 ? void 0 : tapAnswers.length)) return null;
    if (isEmpty(result)) return null;
    var existingLabels = [];
    var tapAnswersById = expectAnswers && tapAnswers.reduce(function(acc, answer) {
        return _object_spread_props(_object_spread({}, acc), _define_property({}, answer.attributes.id, answer.attributes.option_text));
    }, {});
    return Object.entries(result.results).filter(function(param) {
        var _param = _sliced_to_array(param, 2), values = _param[1];
        return values !== null;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), answerKey = _param[0], waveValues = _param[1];
        var answerLabel = (tapAnswersById === null || tapAnswersById === void 0 ? void 0 : tapAnswersById[answerKey]) || answerKey;
        var existingLabelCount = existingLabels.filter(function(label) {
            return label === answerLabel;
        }).length;
        var label = !!existingLabelCount ? "".concat(answerLabel, " ").concat(existingLabelCount + 1) : answerLabel;
        existingLabels.push(answerLabel);
        return {
            id: label,
            data: waveValues.sort(function(a, b) {
                return a.tap_survey_id - b.tap_survey_id;
            }).map(function(wave) {
                return {
                    x: chartWaveLabels[wave.tap_survey_id],
                    y: usePercentage ? wave.percentage : wave.value
                };
            })
        };
    });
}
export var useFormatResultsData = function(param) {
    var result = param.result, tapAnswers = param.tapAnswers, questionType = param.questionType, chartWaveLabels = param.chartWaveLabels, usePercentage = param.usePercentage;
    var constants = useAsset().constants;
    var memoDeps = JSON.stringify(_object_spread_props(_object_spread({}, result, tapAnswers, chartWaveLabels), {
        questionType: questionType,
        usePercentage: usePercentage
    }));
    var formattedData = useMemo(function() {
        return formatResultsData([
            constants.TAP_ANSWER_TYPE_MULTIPLE_CHOICE,
            constants.TAP_ANSWER_TYPE_IMAGE_CHOICE,
            constants.TAP_ANSWER_TYPE_RANKING
        ], result, tapAnswers, questionType, chartWaveLabels, usePercentage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        memoDeps
    ]);
    return formattedData;
};
